// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__2nXaZ","label":"Checkbox_label__ZrTRd"};